<template>
  <div
    class="flex-grow flex-shrink w-full min-w-0 pl-0 pr-0 overflow-auto bg-white settings dark:bg-slate-800"
  >
    <setting-intro-banner
      :header-image="inbox.avatarUrl"
      :header-title="inboxName"
    >
      <woot-tabs
        class="settings--tabs"
        :index="selectedTabIndex"
        :border="false"
        @change="onTabChange"
      >
        <woot-tabs-item
          v-for="tab in tabs"
          :key="tab.key"
          :name="tab.name"
          :show-badge="false"
        />
      </woot-tabs>
    </setting-intro-banner>

    <div v-if="selectedTabKey === 'inbox_settings'" class="settings--content">
      <settings-section
        :title="$t('INBOX_MGMT.SETTINGS_POPUP.INBOX_UPDATE_TITLE')"
        :sub-title="$t('INBOX_MGMT.SETTINGS_POPUP.INBOX_UPDATE_SUB_TEXT')"
        :show-border="false"
      >
        <woot-avatar-uploader
          :label="$t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_AVATAR.LABEL')"
          :src="avatarUrl"
          class="pb-4"
          delete-avatar
          @change="handleImageUpload"
          @onAvatarDelete="handleAvatarDelete"
        />

        <div v-if="isA99digitalSmsInbox" class="w-[75%] pb-4">
          <label>
            {{ $t('INBOX_MGMT.ADD.SMS.PACKAGE.LABEL') }}
          </label>
          <select v-model="smsPackage">
            <option
              v-for="option in smsPackageOptions"
              :key="option.value"
              :value="option.value"
            >
              {{ option.title }}
            </option>
          </select>
          <p v-if="smsPackage" class="help-text">{{ message }}</p>
        </div>

        <woot-input
          v-model.trim="selectedInboxName"
          class="w-[75%] pb-4"
          :class="{ error: $v.selectedInboxName.$error }"
          :label="inboxNameLabel"
          :placeholder="inboxNamePlaceHolder"
          :error="
            $v.selectedInboxName.$error
              ? $t('INBOX_MGMT.ADD.CHANNEL_NAME.ERROR')
              : ''
          "
          @blur="$v.selectedInboxName.$touch"
        />
        <!-- d99d 99hub: onboarding link while pending, external page link once connected -->
        <woot-input
          v-if="isAHubInbox && isHubPending"
          :value="inbox.onboarding_link"
          class="w-[75%]"
          is-disabled
          :label="$t('INBOX_MGMT.SETTINGS_POPUP.HUB.ONBOARDING_LINK')"
        />
        <woot-input
          v-if="isAHubInbox && !isHubPending"
          :value="hubExternalLink"
          class="w-[75%]"
          is-disabled
          :label="$t('INBOX_MGMT.SETTINGS_POPUP.HUB.PAGE_LINK')"
        />
        <woot-input
          v-if="
            isAPIInbox ||
            isAFacebookInbox ||
            isATelegramChannel ||
            isAFacebook2Inbox
          "
          v-model.trim="webhookUrl"
          class="w-[75%] pb-4"
          :is-disabled="isAWhatsAppChannel"
          :class="{ error: $v.webhookUrl.$error }"
          :label="
            $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WEBHOOK_URL.LABEL')
          "
          :placeholder="
            $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WEBHOOK_URL.PLACEHOLDER')
          "
          :error="
            $v.webhookUrl.$error
              ? $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WEBHOOK_URL.ERROR')
              : ''
          "
          @blur="$v.webhookUrl.$touch"
        />
        <woot-input
          v-if="isAWebWidgetInbox"
          v-model.trim="channelWebsiteUrl"
          class="w-[75%] pb-4"
          :label="$t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_DOMAIN.LABEL')"
          :placeholder="
            $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_DOMAIN.PLACEHOLDER')
          "
        />
        <woot-input
          v-if="isAWebWidgetInbox"
          v-model.trim="channelWelcomeTitle"
          class="w-[75%] pb-4"
          :label="
            $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WELCOME_TITLE.LABEL')
          "
          :placeholder="
            $t(
              'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WELCOME_TITLE.PLACEHOLDER'
            )
          "
        />
        <woot-input
          v-if="isAWebWidgetInbox"
          v-model.trim="displayName"
          class="w-[75%] pb-4"
          :label="
            $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_DISPLAY_NAME.LABEL')
          "
          :placeholder="
            $t(
              'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_DISPLAY_NAME.PLACEHOLDER'
            )
          "
        />

        <woot-input
          v-if="isAWebWidgetInbox"
          v-model.trim="channelWelcomeTagline"
          class="w-[75%] pb-4"
          :label="
            $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WELCOME_TAGLINE.LABEL')
          "
          :placeholder="
            $t(
              'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WELCOME_TAGLINE.PLACEHOLDER'
            )
          "
        />

        <label v-if="isAWebWidgetInbox" class="w-[75%] pb-4">
          {{ $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.WIDGET_COLOR.LABEL') }}
          <woot-color-picker v-model="inbox.widget_color" />
        </label>

        <label v-if="isAWhatsAppChannel" class="w-[75%] pb-4">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.LABEL') }}
          <input v-model="whatsAppAPIProviderName" type="text" disabled />
        </label>

        <label v-if="isAnIncomingCallsChannel" class="w-[75%] pb-4">
          {{ $t('INBOX_MGMT.ADD.INCOMING_CALLS.LABEL') }}
          <input
            :value="`https://api.99digital.co.il/online/incomingCalls?identifier=${incomingCallsInboxIdentifier}`"
            type="text"
            disabled
          />
          <p class="pb-1 text-sm not-italic text-slate-600 dark:text-slate-400">
          {{ $t('INBOX_MGMT.ADD.INCOMING_CALLS.HELP_TEXT') }}
          </p>
        </label>

        <label v-if="!isAFacebook2Inbox" class="w-[75%] pb-4">
          {{
            $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_GREETING_TOGGLE.LABEL')
          }}
          <select v-model="greetingEnabled">
            <option :value="true">
              {{
                $t(
                  'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_GREETING_TOGGLE.ENABLED'
                )
              }}
            </option>
            <option :value="false">
              {{
                $t(
                  'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_GREETING_TOGGLE.DISABLED'
                )
              }}
            </option>
          </select>
          <p class="pb-1 text-sm not-italic text-slate-600 dark:text-slate-400">
            {{
              $t(
                'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_GREETING_TOGGLE.HELP_TEXT'
              )
            }}
          </p>
        </label>
        <div v-if="greetingEnabled" class="pb-4">
          <greetings-editor
            v-model.trim="greetingMessage"
            :label="
              $t(
                'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_GREETING_MESSAGE.LABEL'
              )
            "
            :placeholder="
              $t(
                'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_GREETING_MESSAGE.PLACEHOLDER'
              )
            "
            :richtext="!textAreaChannels"
          />
        </div>
        <label v-if="isAWebWidgetInbox" class="w-[75%] pb-4">
          {{ $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.REPLY_TIME.TITLE') }}
          <select v-model="replyTime">
            <option key="in_a_few_minutes" value="in_a_few_minutes">
              {{
                $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.REPLY_TIME.IN_A_FEW_MINUTES')
              }}
            </option>
            <option key="in_a_few_hours" value="in_a_few_hours">
              {{
                $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.REPLY_TIME.IN_A_FEW_HOURS')
              }}
            </option>
            <option key="in_a_day" value="in_a_day">
              {{ $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.REPLY_TIME.IN_A_DAY') }}
            </option>
          </select>

          <p class="pb-1 text-sm not-italic text-slate-600 dark:text-slate-400">
            {{ $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.REPLY_TIME.HELP_TEXT') }}
          </p>
        </label>

        <label v-if="isAWebWidgetInbox" class="w-[75%] pb-4">
          {{ $t('INBOX_MGMT.SETTINGS_POPUP.ENABLE_EMAIL_COLLECT_BOX') }}
          <select v-model="emailCollectEnabled">
            <option :value="true">
              {{ $t('INBOX_MGMT.EDIT.EMAIL_COLLECT_BOX.ENABLED') }}
            </option>
            <option :value="false">
              {{ $t('INBOX_MGMT.EDIT.EMAIL_COLLECT_BOX.DISABLED') }}
            </option>
          </select>
          <p class="pb-1 text-sm not-italic text-slate-600 dark:text-slate-400">
            {{
              $t('INBOX_MGMT.SETTINGS_POPUP.ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT')
            }}
          </p>

          <div v-if="emailCollectEnabled" class="flex flex-col gap-2 mt-2">
            <woot-input
              v-model.trim="emailCollectConfig.explanation_text"
              :label="
                $t(
                  'INBOX_MGMT.SETTINGS_POPUP.ENABLE_EMAIL_COLLECT_BOX_SECTION.EXPLANATION_LABEL'
                )
              "
              :placeholder="
                $t(
                  'INBOX_MGMT.SETTINGS_POPUP.ENABLE_EMAIL_COLLECT_BOX_SECTION.EXPLANATION_SAMPLE'
                )
              "
            />

            <woot-input
              v-model.trim="emailCollectConfig.email_text"
              :label="
                $t(
                  'INBOX_MGMT.SETTINGS_POPUP.ENABLE_EMAIL_COLLECT_BOX_SECTION.EMAIL_TEXT_LABEL'
                )
              "
              :placeholder="
                $t(
                  'INBOX_MGMT.SETTINGS_POPUP.ENABLE_EMAIL_COLLECT_BOX_SECTION.EMAIL_TEXT_SAMPLE'
                )
              "
            />

            <woot-input
              v-model.trim="emailCollectConfig.email_placeholder_text"
              :label="
                $t(
                  'INBOX_MGMT.SETTINGS_POPUP.ENABLE_EMAIL_COLLECT_BOX_SECTION.EMAIL_PLACEHOLDER_LABEL'
                )
              "
              :placeholder="
                $t(
                  'INBOX_MGMT.SETTINGS_POPUP.ENABLE_EMAIL_COLLECT_BOX_SECTION.EMAIL_PLACEHOLDER_SAMPLE'
                )
              "
            />
          </div>
        </label>

        <label class="w-[75%] pb-1">
          {{ $t('INBOX_MGMT.EDIT.AUTO_RESOLVE_DISABLED') }}
          <input
            v-model="autoResolveDisabled"
            type="checkbox"
            value="auto_resolve_disabled"
            @input="handleAutoResolveDisabled"
          />
        </label>
        <label class="w-[75%] pb-4">
          {{ $t('INBOX_MGMT.EDIT.AUTO_RESOLVE.LABEL') }}
          <woot-input
            v-model="autoResolveTime"
            :is-disabled="autoResolveDisabled"
            :placeholder="$t('INBOX_MGMT.EDIT.AUTO_RESOLVE.PLACEHOLDER')"
            class="mb-0"
            type="number"
            :class="{ error: $v.autoResolveTime.$error }"
            :error="
              $v.autoResolveTime.$error
                ? $t('INBOX_MGMT.EDIT.AUTO_RESOLVE.ERROR')
                : ''
            "
            @blur="$v.autoResolveTime.$touch"
          />
          <br />
          <select v-model="autoResolveTimeUnit" :disabled="autoResolveDisabled">
            <option value="minutes">
              {{ $t('INBOX_MGMT.EDIT.AUTO_RESOLVE.MINUTES') }}
            </option>
            <option value="hours">
              {{ $t('INBOX_MGMT.EDIT.AUTO_RESOLVE.HOURS') }}
            </option>
          </select>
          <p class="pb-1 text-sm not-italic text-slate-600 dark:text-slate-400">
            {{ $t('INBOX_MGMT.EDIT.AUTO_RESOLVE.SUB_TEXT') }}
          </p>
          <woot-input
            v-model="autoResolveText"
            :is-disabled="autoResolveDisabled"
            :placeholder="$t('INBOX_MGMT.EDIT.AUTO_RESOLVE_TEXT.PLACEHOLDER')"
            class="mb-0"
            type="text"
          />
          <p class="pb-1 text-sm not-italic text-slate-600 dark:text-slate-400">
            {{ $t('INBOX_MGMT.EDIT.AUTO_RESOLVE_TEXT.SUB_TEXT') }}
          </p>
        </label>

        <label v-if="isAWebWidgetInbox" class="w-[75%] pb-4">
          {{ $t('INBOX_MGMT.SETTINGS_POPUP.ALLOW_MESSAGES_AFTER_RESOLVED') }}
          <select
            v-model="allowMessagesAfterResolved"
            :disabled="autoResolveDisabled"
          >
            <option :value="true">
              {{ $t('INBOX_MGMT.EDIT.ALLOW_MESSAGES_AFTER_RESOLVED.ENABLED') }}
            </option>
            <option :value="false">
              {{ $t('INBOX_MGMT.EDIT.ALLOW_MESSAGES_AFTER_RESOLVED.DISABLED') }}
            </option>
          </select>
          <p class="pb-1 text-sm not-italic text-slate-600 dark:text-slate-400">
            {{
              $t(
                'INBOX_MGMT.SETTINGS_POPUP.ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT'
              )
            }}
          </p>
        </label>

        <label v-if="isAWebWidgetInbox" class="w-[75%] pb-4">
          {{ $t('INBOX_MGMT.SETTINGS_POPUP.ENABLE_CONTINUITY_VIA_EMAIL') }}
          <select v-model="continuityViaEmail">
            <option :value="true">
              {{ $t('INBOX_MGMT.EDIT.ENABLE_CONTINUITY_VIA_EMAIL.ENABLED') }}
            </option>
            <option :value="false">
              {{ $t('INBOX_MGMT.EDIT.ENABLE_CONTINUITY_VIA_EMAIL.DISABLED') }}
            </option>
          </select>
          <p class="pb-1 text-sm not-italic text-slate-600 dark:text-slate-400">
            {{
              $t(
                'INBOX_MGMT.SETTINGS_POPUP.ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT'
              )
            }}
          </p>
        </label>
        <div v-if="false /* d99d */" class="w-[75%] pb-4">
          <label>
            {{ $t('INBOX_MGMT.HELP_CENTER.LABEL') }}
          </label>
          <select v-model="selectedPortalSlug" class="filter__question">
            <option value="">
              {{ $t('INBOX_MGMT.HELP_CENTER.PLACEHOLDER') }}
            </option>
            <option v-for="p in portals" :key="p.slug" :value="p.slug">
              {{ p.name }}
            </option>
          </select>
          <p class="pb-1 text-sm not-italic text-slate-600 dark:text-slate-400">
            {{ $t('INBOX_MGMT.HELP_CENTER.SUB_TEXT') }}
          </p>
        </div>
        <label v-if="isAWebWidgetInbox">
          {{ $t('INBOX_MGMT.FEATURES.LABEL') }}
        </label>
        <div v-if="isAWebWidgetInbox" class="pt-2 pb-4">
          <input
            v-model="selectedFeatureFlags"
            type="checkbox"
            value="attachments"
            @input="handleFeatureFlag"
          />
          <label for="attachments">
            {{ $t('INBOX_MGMT.FEATURES.DISPLAY_FILE_PICKER') }}
          </label>
        </div>
        <div v-if="isAWebWidgetInbox" class="pb-4">
          <input
            v-model="selectedFeatureFlags"
            type="checkbox"
            value="emoji_picker"
            @input="handleFeatureFlag"
          />
          <label for="emoji_picker">
            {{ $t('INBOX_MGMT.FEATURES.DISPLAY_EMOJI_PICKER') }}
          </label>
        </div>
        <div v-if="isAWebWidgetInbox" class="pb-4">
          <input
            v-model="selectedFeatureFlags"
            type="checkbox"
            value="end_conversation"
            @input="handleFeatureFlag"
          />
          <label for="end_conversation">
            {{ $t('INBOX_MGMT.FEATURES.ALLOW_END_CONVERSATION') }}
          </label>
        </div>
        <div v-if="isAWebWidgetInbox" class="pb-4">
          <input
            v-model="selectedFeatureFlags"
            type="checkbox"
            value="use_inbox_avatar_for_bot"
            @input="handleFeatureFlag"
          />
          <label for="emoji_picker">
            {{ $t('INBOX_MGMT.FEATURES.USE_INBOX_AVATAR_FOR_BOT') }}
          </label>
        </div>
      </settings-section>
      <settings-section
        v-if="isAWebWidgetInbox || isAnEmailChannel"
        :title="$t('INBOX_MGMT.EDIT.SENDER_NAME_SECTION.TITLE')"
        :sub-title="$t('INBOX_MGMT.EDIT.SENDER_NAME_SECTION.SUB_TEXT')"
        :show-border="false"
      >
        <div class="w-[75%] pb-4">
          <sender-name-example-preview
            :sender-name-type="senderNameType"
            :business-name="businessName"
            @update="toggleSenderNameType"
          />
          <div class="flex flex-col items-start gap-2 mt-2">
            <woot-button
              variant="clear"
              color-scheme="primary"
              @click="onClickShowBusinessNameInput"
            >
              {{
                $t(
                  'INBOX_MGMT.EDIT.SENDER_NAME_SECTION.BUSINESS_NAME.BUTTON_TEXT'
                )
              }}
            </woot-button>
            <div v-if="showBusinessNameInput" class="flex gap-2 w-[80%]">
              <input
                ref="businessNameInput"
                v-model="businessName"
                :placeholder="
                  $t(
                    'INBOX_MGMT.EDIT.SENDER_NAME_SECTION.BUSINESS_NAME.PLACEHOLDER'
                  )
                "
                class="mb-0"
                type="text"
              />
              <woot-button color-scheme="primary" @click="updateInbox">
                {{
                  $t(
                    'INBOX_MGMT.EDIT.SENDER_NAME_SECTION.BUSINESS_NAME.SAVE_BUTTON_TEXT'
                  )
                }}
              </woot-button>
            </div>
          </div>
        </div>
      </settings-section>
      <settings-section :show-border="false">
        <woot-submit-button
          v-if="
            isAPIInbox ||
            isAFacebookInbox ||
            isATelegramChannel ||
            isAFacebook2Inbox
          "
          type="submit"
          :disabled="$v.webhookUrl.$invalid"
          :button-text="$t('INBOX_MGMT.SETTINGS_POPUP.UPDATE')"
          :loading="uiFlags.isUpdating"
          @click="updateInbox"
        />
        <woot-submit-button
          v-else
          type="submit"
          :disabled="$v.$invalid"
          :button-text="$t('INBOX_MGMT.SETTINGS_POPUP.UPDATE')"
          :loading="uiFlags.isUpdating"
          @click="updateInbox"
        />
      </settings-section>
      <facebook-reauthorize v-if="isAFacebookInbox || isAFacebook2Inbox " :channel="isAFacebookInbox ? 'facebook' : 'facebook2'" :inbox-id="inbox.id" />
      <tiktok-reauthorize v-if="isATiktokChannel" :inbox-id="inbox.id" />
      <gmail-reauthorize v-if="isAGmailChannel" :inbox-id="inbox.id" />
      <gmail-sync-settings v-if="isAGmailChannel" :inbox="inbox" />
      <microsoft-reauthorize v-if="isAMicrosoftApiChannel" :inbox="inbox" />
    </div>

    <div v-if="selectedTabKey === 'collaborators'" class="settings--content">
      <collaborators-page :inbox="inbox" />
    </div>
    <div v-if="selectedTabKey === 'configuration'">
      <configuration-page :inbox="inbox" />
    </div>
    <div v-if="selectedTabKey === 'profilePage'">
      <profile-page :inbox="inbox" />
    </div>
    <div v-if="selectedTabKey === 'preChatForm'">
      <pre-chat-form-settings :inbox="inbox" />
    </div>
    <div v-if="selectedTabKey === 'businesshours'">
      <dstudio-bot-configuration v-if="isStudioEnabled" :inbox="inbox" />
            <weekly-availability :inbox="inbox" />
    </div>
    <woot-modal :show.sync="showImportModal" :on-close="onToggleImport">
      <import-conversations
        v-if="showImportModal"
        :inbox-id="inbox.id"
        :on-close="onToggleImport"
      />
    </woot-modal>
    <div v-if="selectedTabKey === 'widgetBuilder'">
      <widget-builder :inbox="inbox" />
    </div>
    <div v-if="selectedTabKey === 'botConfiguration'">
      <bot-configuration :inbox="inbox" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { shouldBeUrl } from 'shared/helpers/Validators';
import configMixin from 'shared/mixins/configMixin';
import alertMixin from 'shared/mixins/alertMixin';
import SettingIntroBanner from 'dashboard/components/widgets/SettingIntroBanner.vue';
import SettingsSection from '../../../../components/SettingsSection.vue';
import inboxMixin from 'shared/mixins/inboxMixin';
import FacebookReauthorize from './facebook/Reauthorize.vue';
import GmailReauthorize from './gmail/Reauthorize'; // d99d
import GmailSyncSettings from './gmail/SyncSettings.vue';
import MicrosoftReauthorize from './channels/microsoft/Reauthorize.vue'; // d99d
import TiktokReauthorize from './tiktok/Reauthorize';
import PreChatFormSettings from './PreChatForm/Settings.vue';
import WeeklyAvailability from './components/WeeklyAvailability.vue';
import GreetingsEditor from 'shared/components/GreetingsEditor.vue';
import ImportConversations from './ImportConversations';
import ConfigurationPage from './settingsPage/ConfigurationPage.vue';
import CollaboratorsPage from './settingsPage/CollaboratorsPage.vue';
import ProfilePage from './settingsPage/ProfilePage.vue'; // d99d
import WidgetBuilder from './WidgetBuilder.vue';
import BotConfiguration from './components/BotConfiguration.vue';
import { FEATURE_FLAGS } from '../../../../featureFlags';
import SenderNameExamplePreview from './components/SenderNameExamplePreview.vue';
import { LIMIT_MESSAGE } from 'shared/constants/inbox'; // d99d
import smsPackageOptionsMixin from 'shared/mixins/inboxSmsPackageOptionsMixin'; // d99d
import DstudioBotConfiguration from './components/DstudioBotConfiguration.vue'; //d99d

export default {
  components: {
    BotConfiguration,
    CollaboratorsPage,
    ProfilePage, // d99d
    FacebookReauthorize,
    GmailReauthorize, // d99d
    GmailSyncSettings,
    MicrosoftReauthorize, // d99d
    TiktokReauthorize, // d99d
    DstudioBotConfiguration, //d99d
    GreetingsEditor,
    PreChatFormSettings,
    SettingIntroBanner,
    SettingsSection,
    WeeklyAvailability,
    GreetingsEditor,
    ImportConversations,
    ConfigurationPage,
    CollaboratorsPage,
    WidgetBuilder,
    SenderNameExamplePreview,
  },
  mixins: [alertMixin, configMixin, inboxMixin, smsPackageOptionsMixin],
  data() {
    return {
      avatarFile: null,
      avatarUrl: '',
      greetingEnabled: true,
      greetingMessage: '',
      emailCollectEnabled: false,
      emailCollectConfig: {},
      senderNameType: 'friendly',
      businessName: '',
      locktoSingleConversation: false,
      allowMessagesAfterResolved: true,
      continuityViaEmail: true,
      selectedInboxName: '',
      channelWebsiteUrl: '',
      webhookUrl: '',
      channelWelcomeTitle: '',
      channelWelcomeTagline: '',
      selectedFeatureFlags: [],
      replyTime: '',
      selectedTabIndex: 0,
      showImportModal: false,
      selectedPortalSlug: '',
      showBusinessNameInput: false,
      smsPackage: '',
      displayName: '',
      autoResolveTimeUnit: 'minutes',
      autoResolveText: null,
      autoResolveTime: 0,
      autoResolveDisabled: true,
    };
  },
  computed: {
    ...mapGetters({
      getWaProfile: 'inboxes/getWaProfile',
      accountId: 'getCurrentAccountId',
      isFeatureEnabledonAccount: 'accounts/isFeatureEnabledonAccount',
      uiFlags: 'inboxes/getUIFlags',
      portals: 'portals/allPortals',
    }),
    selectedTabKey() {
      return this.tabs[this.selectedTabIndex]?.key;
    },
    whatsAppAPIProviderName() {
      if (this.isAWhatsAppCloudChannel) {
        return this.$t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.WHATSAPP_CLOUD');
      }
      if (this.is360DialogWhatsAppChannel) {
        return this.$t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.360_DIALOG');
      }
      if (this.isATwilioWhatsAppChannel) {
        return this.$t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.TWILIO');
      }
      return '';
    },
    tabs() {
      let visibleToAllChannelTabs = [
        {
          key: 'inbox_settings',
          name: this.$t('INBOX_MGMT.TABS.SETTINGS'),
        },
        {
          key: 'collaborators',
          name: this.$t('INBOX_MGMT.TABS.COLLABORATORS'),
        },
        {
          key: 'businesshours',
          name: this.$t('INBOX_MGMT.TABS.CHATBOTS'),
        },
      ];

      if (this.isAWebWidgetInbox) {
        visibleToAllChannelTabs = [
          ...visibleToAllChannelTabs,
          {
            key: 'preChatForm',
            name: this.$t('INBOX_MGMT.TABS.PRE_CHAT_FORM'),
          },
          {
            key: 'widgetBuilder',
            name: this.$t('INBOX_MGMT.TABS.WIDGET_BUILDER'),
          },
        ];
      }

      if (
        this.isATwilioChannel ||
        this.isALineChannel ||
        this.isAPIInbox ||
        (this.isAnEmailChannel && !this.inbox.provider) ||
        (this.isAnEmailChannel && this.inbox.provider === 'microsoft') ||
        this.isAWhatsAppChannel ||
        this.isAWebWidgetInbox
      ) {
        visibleToAllChannelTabs = [
          ...visibleToAllChannelTabs,
          {
            key: 'configuration',
            name: this.$t('INBOX_MGMT.TABS.CONFIGURATION'),
          },
        ];
      }

      if (
        this.isFeatureEnabledonAccount(
          this.accountId,
          FEATURE_FLAGS.AGENT_BOTS
        ) &&
        !(this.isAnEmailChannel || this.isATwitterInbox) &&
        false // d99d
      ) {
        visibleToAllChannelTabs = [
          ...visibleToAllChannelTabs,
          {
            key: 'botConfiguration',
            name: this.$t('INBOX_MGMT.TABS.BOT_CONFIGURATION'),
          },
        ];
      }

      if (this.isOnlineWaInboxV23) {
        visibleToAllChannelTabs = [
          ...visibleToAllChannelTabs,
          {
            key: 'profilePage',
            name: this.$t('INBOX_MGMT.TABS.PROFILE'),
          },
        ];
      }

      return visibleToAllChannelTabs;
    },
    currentInboxId() {
      return this.$route.params.inboxId;
    },
    inbox() {
      return this.$store.getters['inboxes/getInbox'](this.currentInboxId);
    },
    // d99d 99hub
    isHubPending() {
      return this.inbox.status === 'pending';
    },
    hubExternalLink() {
      if (this.isHubInstagramInbox) {
        const username = this.inbox.additional_attributes?.instagram_username;
        return username ? `https://instagram.com/${username}` : '';
      }
      return this.inbox.page_link || '';
    },

    waProfile() {
      // eslint-disable-next-line no-unused-expressions
      this.getWaProfile;
      return this.$store.getters['inboxes/getWaProfileById'](
        this.currentInboxId
      );
    },
    inboxName() {
      if (this.isATwilioSMSChannel || this.isATwilioWhatsAppChannel) {
        return `${this.inbox.name} (${
          this.inbox.messaging_service_sid || this.inbox.phone_number
        })`;
      }
      if (this.isAWhatsAppChannel) {
        const phoneNumber = this.waProfile ? `(${this.waProfile.from})` : '';
        return [this.inbox.name, phoneNumber].join(' ');
      }
      if (this.isAnEmailChannel) {
        return `${this.inbox.name} (${this.inbox.email})`;
      }
      if (this.inbox.channel_type === 'Channel::Sms') {
        return `${this.inbox.name} (0${this.inbox.phone_number.slice(3) || ''})`;
      }
      return this.inbox.name;
    },
    canLocktoSingleConversation() {
      return this.isASmsInbox || this.isAWhatsAppChannel;
    },
    inboxNameLabel() {
      if (this.isAWebWidgetInbox) {
        return this.$t('INBOX_MGMT.ADD.WEBSITE_NAME.LABEL');
      }
      return this.$t('INBOX_MGMT.ADD.CHANNEL_NAME.LABEL');
    },
    inboxNamePlaceHolder() {
      if (this.isAWebWidgetInbox) {
        return this.$t('INBOX_MGMT.ADD.WEBSITE_NAME.PLACEHOLDER');
      }
      return this.$t('INBOX_MGMT.ADD.CHANNEL_NAME.PLACEHOLDER');
    },
    textAreaChannels() {
      if (
        this.isATwilioChannel ||
        this.isATwitterInbox ||
        this.isAFacebookInbox ||
        this.isAPIInbox // d99d
      )
        return true;
      return false;
    },
    // d99d
    isStudioEnabled() {
      return this.isFeatureEnabledonAccount(
          this.accountId,
          FEATURE_FLAGS.STUDIO
      );
    },
    // .
    message() {
      return this.$t('INBOX_MGMT.ADD.SMS.PACKAGE.LIMIT_MESSAGE', {
        limit: LIMIT_MESSAGE[this.smsPackage],
      });
    },
    incomingCallsInboxIdentifier() {
      return this.inbox?.inbox_identifier || '';
    },
  },
  watch: {
    $route(to) {
      if (to.name === 'settings_inbox_show') {
        this.fetchInboxSettings();
      }
    },
  },
  mounted() {
    this.fetchInboxSettings();
    this.fetchPortals();
  },
  methods: {
    fetchPortals() {
      this.$store.dispatch('portals/index');
    },
    handleFeatureFlag(e) {
      this.selectedFeatureFlags = this.toggleInput(
        this.selectedFeatureFlags,
        e.target.value
      );
    },
    handleAutoResolveDisabled(e) {
      this.autoResolveDisabled = this.toggleInput(
        this.autoResolveDisabled,
        e.target.value
      );
    },
    handleHmacFlag() {
      this.updateInbox();
    },
    toggleInput(selected, current) {
      if (selected.includes(current)) {
        const newSelectedFlags = selected.filter(flag => flag !== current);
        return newSelectedFlags;
      }
      return [...selected, current];
    },
    onTabChange(selectedTabIndex) {
      this.selectedTabIndex = selectedTabIndex;
    },
    fetchInboxSettings() {
      this.selectedTabIndex = 0;
      this.selectedAgents = [];
      this.$store.dispatch('agents/get');
      this.$store.dispatch('teams/get');
      this.$store.dispatch('labels/get');
      this.$store.dispatch('inboxes/get').then(() => {
        this.smsPackage = this.inbox.sms_package;
        this.avatarUrl = this.inbox.avatar_url;
        this.selectedInboxName = this.inbox.name;
        this.webhookUrl = this.inbox.webhook_url;
        this.greetingEnabled = this.inbox.greeting_enabled || false;
        this.greetingMessage = this.inbox.greeting_message || '';
        this.emailCollectEnabled = this.inbox.enable_email_collect;
        this.emailCollectConfig =
          typeof this.inbox.email_collect_config === 'object' &&
          this.inbox.email_collect_config !== null
            ? this.inbox.email_collect_config
            : {};
        this.senderNameType = this.inbox.sender_name_type;
        this.businessName = this.inbox.business_name;
        this.allowMessagesAfterResolved =
          this.inbox.allow_messages_after_resolved;
        this.continuityViaEmail = this.inbox.continuity_via_email;
        this.channelWebsiteUrl = this.inbox.website_url;
        this.channelWelcomeTitle = this.inbox.welcome_title;
        this.channelWelcomeTagline = this.inbox.welcome_tagline;
        this.selectedFeatureFlags = this.inbox.selected_feature_flags || [];
        this.replyTime = this.inbox.reply_time;
        this.autoResolveTime = this.inbox.auto_resolve_time;
        this.autoResolveTimeUnit = this.inbox.auto_resolve_time_unit;
        this.autoResolveText = this.inbox.auto_resolve_text;
        this.autoResolveDisabled = this.inbox.auto_resolve_disabled;
        this.selectedPortalSlug = this.inbox.help_center
          ? this.inbox.help_center.slug
          : '';
        this.displayName = this.inbox.display_name;
      });
    },
    async updateInbox() {
      try {
        const payload = {
          id: this.currentInboxId,
          name: this.selectedInboxName,
          enable_email_collect: this.emailCollectEnabled,
          csat_survey_enabled: this.csatSurveyEnabled,
          allow_messages_after_resolved: this.allowMessagesAfterResolved,
          greeting_enabled: this.greetingEnabled,
          greeting_message: this.greetingMessage || '',
          auto_resolve_time: this.autoResolveTime,
          auto_resolve_time_unit: this.autoResolveTimeUnit,
          auto_resolve_text: this.autoResolveText || '',
          auto_resolve_disabled: this.autoResolveDisabled,
          portal_id: this.selectedPortalSlug
            ? this.portals.find(
                portal => portal.slug === this.selectedPortalSlug
              ).id
            : null,
          sender_name_type: this.senderNameType,
          business_name: this.businessName || null,
          channel: {
            display_name: this.displayName,
            widget_color: this.inbox.widget_color,
            website_url: this.channelWebsiteUrl,
            welcome_title: this.channelWelcomeTitle || '',
            welcome_tagline: this.channelWelcomeTagline || '',
            selectedFeatureFlags: this.selectedFeatureFlags,
            reply_time: this.replyTime || 'in_a_few_minutes',
            continuity_via_email: this.continuityViaEmail,
            sms_package: this.smsPackage,
            email_collect_config: this.emailCollectConfig,
          },
        };
        if (!this.isAWhatsAppChannel) {
          payload.channel.webhook_url = this.webhookUrl;
        }
        if (this.avatarFile) {
          payload.avatar = this.avatarFile;
        }
        await this.$store.dispatch('inboxes/updateInbox', payload);
        this.showAlert(this.$t('INBOX_MGMT.EDIT.API.SUCCESS_MESSAGE'));
      } catch (error) {
        this.showAlert(
          error.message || this.$t('INBOX_MGMT.EDIT.API.ERROR_MESSAGE')
        );
      }
    },
    handleImageUpload({ file, url }) {
      this.avatarFile = file;
      this.avatarUrl = url;
    },
    async handleAvatarDelete() {
      try {
        await this.$store.dispatch(
          'inboxes/deleteInboxAvatar',
          this.currentInboxId
        );
        this.avatarFile = null;
        this.avatarUrl = '';
        this.showAlert(this.$t('INBOX_MGMT.DELETE.API.AVATAR_SUCCESS_MESSAGE'));
      } catch (error) {
        this.showAlert(
          error.message
            ? error.message
            : this.$t('INBOX_MGMT.DELETE.API.AVATAR_ERROR_MESSAGE')
        );
      }
    },
    onToggleImport() {
      this.showImportModal = !this.showImportModal;
    },
    toggleSenderNameType(key) {
      this.senderNameType = key;
    },
    onClickShowBusinessNameInput() {
      this.showBusinessNameInput = !this.showBusinessNameInput;
      if (this.showBusinessNameInput) {
        this.$nextTick(() => {
          this.$refs.businessNameInput.focus();
        });
      }
    },
  },
  validations() {
    return {
      webhookUrl: {
        shouldBeUrl,
      },
      selectedInboxName: {},
      autoResolveTime: {
        required: false,
        custom: value => {
          const intVal = parseInt(value, 10);
          if (this.autoResolveTimeUnit === 'minutes') {
            return intVal === 0 || (intVal >= 30 && intVal <= 1440);
          }

          if (this.autoResolveTimeUnit === 'hours') {
            return intVal === 0 || intVal <= 24;
          }

          return false;
        },
      },
    };
  },
};
</script>

<style scoped lang="scss">
.settings {
  .settings--tabs {
    ::v-deep .tabs {
      @apply p-0;
    }
  }
}
</style>
